<div class="max-w-screen-xl mx-auto p-4 bg-white rounded-lg shadow-sm">
    <p class="text-[28px] leading-9 font-bold mb-4 text-palette-blue-600 text-center">How to become TMTravel Hotel partner and Create a new hotel on TMTravel</p>
    <div class="flex gap-6">
        <button *ngIf="!isSidebarOpen"
            class="md:hidden fixed top-4 left-2 z-50 bg-blue-600 text-white !px-3 !py-2 rounded shadow"
            (click)="isSidebarOpen = !isSidebarOpen">
            <i class="sctr-icon-menu-01"></i>
        </button>
        <!-- Sidebar -->
        <aside class="w-[280px] md:w-[330px] p-4 border rounded shadow bg-white 
                md:sticky md:!top-[80px] md:mt-4 h-fit z-40
                fixed top-[6px] left-0 md:!h-full overflow-auto transition-transform duration-300 
                md:transform-none"
            [ngClass]="{
                '-translate-x-full': !isSidebarOpen,
                'translate-x-0': isSidebarOpen,
                'md:translate-x-0': true
            }">
             <button *ngIf="isSidebarOpen"
                class="md:hidden fixed top-2 left-[14.5rem] z-50 bg-blue-600 text-white !px-3 !py-2 rounded shadow"
                (click)="isSidebarOpen = !isSidebarOpen">
                <i class="sctr-icon-x-close"></i>
            </button>
            <h2 class="text-lg font-semibold mb-3 text-palette-blue-600">What's on this page:</h2>
            <ul class="space-y-2 text-sm text-gray-800">
                <li>
                    <button (click)="selectSection('register')" [ngClass]="buttonClass('register')">
                       <h2 class="md:whitespace-nowrap font-bold">I. Register as a TMTravel Hotel’s partner</h2> 
                    </button>
                </li>
                <li>
                    <button (click)="selectSection('create')" [ngClass]="buttonClass('create')">
                       <h2 class="md:whitespace-nowrap font-bold">II. Create your hotel on TMTravel</h2> 
                    </button>
                    <ul class="pl-4 list-decimal text-gray-600 mt-1 space-y-1">
                        <li *ngFor="let item of createSteps">
                            <button class="whitespace-normal break-words" type="button" (click)="selectSection(item.key)" [ngClass]="buttonClass(item.key)">
                                {{ item.label }}
                            </button>
                        </li>
                    </ul>
                </li>
                <li>
                    <button (click)="selectSection('channel')" [ngClass]="buttonClass('channel')">
                        <h2 class="md:whitespace-nowrap font-bold">III. Setup for hotels using channel manager</h2>
                    </button>
                    <ul class="pl-4 list-decimal text-gray-600 mt-1 space-y-1">
                        <li *ngFor="let item of channelSteps">
                            <button class="whitespace-normal break-words" (click)="selectSection(item.key)" [ngClass]="buttonClass(item.key)">
                                {{ item.label }}
                            </button>
                        </li>
                    </ul>
                </li>
            </ul>
        </aside>
        <!-- Content -->
        <section class="flex-1 mt-4">
            <div id="register" class="mb-10">
                <h2 class="text-xl font-bold mb-2">I. Register as a TMTravel Hotel’s partner</h2>
                <p class="text-gray-900 mb-1">
                    To get started, you need to register as an Agency on TMTravel:
                </p>
                <ul class="list-disc list-inside text-gray-900 mb-4 pl-6">
                    <li>Log in to the TMTravel social platform</li>
                    <li>
                        Go to the top-right menu → <strong>Partner Center</strong> → <strong>Hotel</strong> module, or click
                        <strong>"Register now"</strong> on the <strong>Become our agency</strong> popup, or
                        <span (click)="navigateToBecameAgency()" class="text-blue-600 hover:underline cursor-pointer">click here</span>
                    </li>
                </ul>
    
                <!-- img -->
                <div class="mb-4">
                    <img src="assets/images/property/1.png" alt="Become our agency form" class="w-full rounded shadow" />
                </div>
                <p class="text-gray-900 mb-2">
                    After that, the system displays the “Become our agency” form as below:
                </p>
                <!-- img -->
                <div class="mb-2 flex justify-center">
                    <img src="assets/images/property/2.png" alt="Registration form" class="w-8 rounded shadow" />
                </div>
    
    
                <p class="text-gray-900 mb-2 font-semibold">
                    Fill in all required fields on the registration form, including:
                </p>
                <ul class="list-disc list-inside text-gray-900 mb-4 pl-6">
                    <li>
                        Your <strong>business information:</strong> legal business name, country, full address, email, and phone number
                    </li>
                    <li>
                        Your <strong>contact details:</strong> full name, email, and phone number of the person TMTravel can reach out to for support or coordination
                    </li>
                </ul>
                <p class="text-gray-900 mb-2">
                    Make sure all information is accurate and up-to-date, as this will be used by TMTravel to verify your identity and communicate with you during the onboarding process.
                </p>
                <p class="text-gray-900">
                    Click <strong>“Send Request”</strong> to submit your application. No approval is required for this step. Once submitted, you can immediately begin creating your hotel profile by clicking “Create new  property”.
                </p>
                <!-- img -->
                <div class="mt-4 flex justify-center">
                    <img src="assets/images/property/3.png" alt="Create new property" class="w-full rounded shadow" />
                </div>
            </div>
            <!-- CREATE  -->
            <div id="create" class="mb-10">
                <h2 class="text-xl font-bold mb-2">II. Create your hotel on TMTravel</h2>
                <p class="text-gray-900 mb-4">
                    After registering your agency, proceed to create your hotel:
                </p>
                <ul class="list-disc list-inside text-gray-900 mb-4 pl-6">
                    <li>Click <strong>“Create New Property”</strong></li>
                    <li>Choose the listing type: <strong>Hotel &gt; Hotel</strong> and click <strong>Continue</strong></li>
                </ul>
    
                <!-- img -->
                <div class="mb-2 flex justify-center">
                    <img src="assets/images/property/4.png" alt="Create New Property Step" class="w-full rounded shadow" />
                </div>
    
                <ol class="list-decimal list-inside text-gray-900 space-y-4 pl-6">
                    <li id="general">
                        <strong>General information</strong><br />
                        <ul class="list-disc list-inside ml-4">
                            <li>Fill in the basic hotel details, ensuring all required fields are completed (e.g. hotel name, description, star rating, CMS integration,..).</li>
                            <li>Enter main contact (required); additional sub-contacts are optional.</li>
                        </ul>
                    </li>
                    <li id="facilities">
                        <strong>Hotel facilities</strong><br />
                        <ul class="list-disc list-inside ml-4">
                            <li>Select your hotel's amenities and services, specifying which are free or paid.</li>
                        </ul>
                    </li>
                    <li id="photos">
                        <strong>Upload hotel photos</strong><br />
                        <ul class="list-disc list-inside ml-4">
                            <li>Upload images of your hotel
                                <ul class="list-[circle] list-inside ml-1">
                                    <li>Recommended: at least 4 in supported formats like JPG, PNG.</li>
                                    <li>Select one as the main image to highlight your property on TMTravel.</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li id="policies">
                        <strong>Set property policies</strong><br />
                        <ul class="list-disc list-inside ml-4">
                            <li>Set your hotel's guest rules: check-in/out times, pet and children policies, cancellation terms, and payment method (Soctrip supports prepayment only).</li>
                        </ul>
                    </li>
                    <li id="rooms">
                        <strong>Create rooms</strong><br />
                        <ul class="list-disc list-inside ml-4">
                            <li>Enter complete details for each room, including type, size, description, images, amenities, and bed setup.</li>
                        </ul>
                    </li>
                    <li id="review">
                        <strong>Review hotel information and Submit the contract</strong>
                        <ul class="list-disc list-inside ml-4">
                            <li>
                                Review all hotel info. Contract details are auto-filled from your agency profile.
                                <ul class="list-[circle] list-inside ml-1">
                                    <li><strong>Individual:</strong> upload business license, enter ID number</li>
                                    <li><strong>Business:</strong> upload business license, ID number, and tax code</li>
                                </ul>
                            </li>
                            <li>
                                Tick “I hereby agree with the content of the above Property Contract,” agree to the terms, and click Submit.
                            </li>
                        </ul>
                    </li>
                </ol>
                <p class="text-gray-900 mt-1">Verification takes 24–72 hours. If rejected, TMTravel will notify you with the reason and next steps. </p>
                <p class="text-gray-900 mt-1">After this step, you can either finish or continue setting up your hotel (rate plans, availability, promotions) by clicking <strong>“Continue Setup.”</strong></p>
    
                <!-- img -->
                <div class="my-2 flex justify-center">
                    <img src="assets/images/property/5.png" alt="Continue after submitting contract"
                        class="w-full rounded shadow" />
                </div>
    
                <ol start="7" class="list-decimal list-inside text-gray-900 space-y-4 pl-6">
                    <li id="rates">
                        <strong>Set room rates (Rate plan)</strong><br />
                        <ul class="list-disc list-inside ml-4">
                            <li>Go to <strong>Rate Plan</strong> &gt; <strong>Add Rate Plan</strong>.</li>
                            <li>Set custom pricing including rate name, cancellation policy, booking restrictions, meals,
                                and included services.</li>
                        </ul>
                    </li>
                    <li id="calendar">
                        <strong>Configure availability calendar</strong>
                        <ul class="list-disc list-inside ml-4">
                            <li>All rooms are initially closed</li>
                            <li>
                                Open rooms by:
                                <ul class="list-[circle] list-inside ml-1">
                                    <li>Selecting room(s) &gt; date range &gt; mark as open</li>
                                    <li>Enter number of rooms, extra bed price, and selling price</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li id="promotions">
                        <strong>Create promotions</strong><br />
                        <ul class="list-disc list-inside ml-4">
                            <li>Define custom pricing</li>
                            <li>Select rooms and rate plans</li>
                            <li>Set discount %, budget (fixed or unlimited), and quantity (fixed or unlimited)</li>
                            <li>System tracks usage and notifies guests if limits are exceeded</li>
                        </ul>
                    </li>
                </ol>
    
                <p class="text-gray-900 mt-4">
                    Your hotel setup on TMTravel is now complete. Once your <strong>property is approved</strong>, it will be
                    visible to users
                    and open for bookings.
                </p>
            </div>
            <!-- CHANNEL -->
            <div id="channel" class="mb-10">
                <h2 class="text-xl font-bold mb-2">III. Setup for hotels using channel manager</h2>
    
                <ol class="list-decimal list-inside text-gray-900 space-y-4 pl-6">
                    <li id="hotelLink">
                        <strong>Connect Hotel Link</strong>
                        <ul class="list-disc list-inside ml-4">
                            <li>During hotel creation, under <strong>General Information</strong>, select
                                <strong>Yes</strong> for “Does this property use a Channel Manager System?”
                            </li>
                            <li>Enter the <strong>Hotel Link ID</strong> and <strong>Authentication Key</strong>, then click
                                <strong>Continue</strong>.
                            </li>
                            <li>If the connection is valid, the system proceeds to the next step.</li>
                        </ul>
                    </li>
    
                    <li id="cancel">
                        <strong>Cancellation policy</strong>
                        <ul class="list-disc list-inside ml-4">
                            <li>Cancellation policies are synced automatically from Hotel Link.</li>
                            <li>These policies are pre-configured via Hotel Link and cannot be adjusted in TMTravel.</li>
                        </ul>
                    </li>
    
                    <li id="roomSetup">
                        <strong>Room setup</strong>
                        <ul class="list-disc list-inside ml-4">
                            <li>Room names are imported from Hotel Link.</li>
                            <li>Details such as room type, description, images, size, and amenities need to be filled in.</li>
                            <li>Rooms appear as “Needs update” if required information is missing.</li>
                            <li>Incomplete rooms are highlighted with a red border and a warning.</li>
                        </ul>
                    </li>
    
                    <li id="ratePlans">
                        <strong>Rate plans</strong>
                        <ul class="list-disc list-inside ml-4">
                            <li>Rate plans are automatically imported from Hotel Link and shown directly in TMTravel for reference.</li>
                            <li>The setup follows the configuration already managed in your Channel Manager.</li>
                        </ul>
                        <!-- img -->
                        <div class="my-2 flex justify-center">
                            <img src="assets/images/property/6.png" alt="Rate plans from Hotel Link"
                                class="w-full max-w-xl rounded shadow" />
                        </div>
                    </li>
    
                    <li id="availability">
                        <strong>Availability calendar</strong>
                        <ul class="list-disc list-inside ml-4">
                            <li>All rooms start in a closed status. To make rooms available for booking:</li>
                            <ul class="list-[circle] list-inside ml-1">
                                <li>Select one or more rooms</li>
                                <li>Choose a date range and mark as open</li>
                                <li>Enter extra bed price (if applicable)</li>
                                <li>Enter the selling price manually</li>
                            </ul>
                        </ul>
                        <div class="mt-1 ml-4">
                            <p class="underline"><strong>Notes:</strong></p>
                            <ul class="list-disc list-inside ml-4">
                                <li>Room quantity is synced from Hotel Link</li>
                                <li>Reference prices from Hotel Link are shown in grey</li>
                                <li>A room becomes available for booking once both the price and the room are marked as open
                                </li>
                            </ul>
                        </div>
    
                        <!-- img -->
                        <div class="my-2 flex justify-center">
                            <img src="assets/images/property/7.png" alt="Availability calendar"
                                class="w-full max-w-xl rounded shadow" />
                        </div>
                    </li>
                </ol>
            </div>
        </section>
    </div>
</div>
<style>
    .popup-cta{
        display: none!important;
    }
</style>